import React from 'react';
import Feed from '../components/Feed/Feed';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import withApollo from '../lib/withApollo';

const VideoFeed = () => {
  return (
    <>
      <Head title="New Travel Videos" feedUrl="created" />
      <Header active="videos" subheader="Videos" />
      <Feed active="videos" minScore={0} orderby="createdAt" />
    </>
  );
};

export default withApollo(VideoFeed);
